// Shared AWS Config recorder status helpers for the CSPM portal pages.
//
// Backend status enum (backend/models/securityhub_config_models.go):
//   none | enabling | enabled | disabling | disabled | removing | failed | external
//
// Keeping these sets in one place keeps the Settings prompt, the Summary
// banner, and the Config Rules selectors consistent.

// A linking region needs a "Set up AWS Config" nudge when there is no confirmed
// running recorder: absent (none), stopped (disabled), or failed to provision
// (failed). `enabled`/`external` are recording, and `enabling`/`disabling`/
// `removing` are transient, so none of those count as missing.
export const MISSING_RECORDER_STATUSES = ['none', 'disabled', 'failed'];

// A recorder is "set up" — present and recording (or coming up) — for the
// purpose of listing its Config rules.
export const SETUP_STATUSES = ['enabled', 'external', 'enabling'];

// Account/region pairs in linking regions that lack a running recorder, and
// therefore need AWS Config enabled before standards can evaluate. Returns
// bare { accountId, region } cells suitable for enableConfigRecorders().
//
// Derived from (every account x every linking region) rather than by filtering
// the returned recorder cells: a JUST-ADDED linking region may not have a
// synthesized cell in the status snapshot yet (the read can lag the region
// save), so an absent cell is treated as 'none' (missing). Accounts come from
// whatever cells the snapshot does have.
export const missingEnableCells = (recorders, linkingRegions) => {
  const recs = recorders || [];
  const accounts = [...new Set(recs.map((r) => r.accountId))];
  const statusByCell = new Map(recs.map((r) => [`${r.accountId}|${r.region}`, r.status]));
  const cells = [];
  accounts.forEach((accountId) => {
    (linkingRegions || []).forEach((region) => {
      const status = statusByCell.get(`${accountId}|${region}`) || 'none';
      if (MISSING_RECORDER_STATUSES.includes(status)) cells.push({ accountId, region });
    });
  });
  return cells;
};
